import React from 'react';
import FileUploader from './FileUploader';
import './App.css';

function App() {
  return (
    <div className="App">
      <header className="App-header">
        <img src="https://cdn.prod.website-files.com/5f24235f84489d3dbd1c838f/62585f73e72f24be469a735f_logo-padrao.svg" style={{ width: '300px', height: 'auto' }} alt="Logo" />
        <h1>Sistema de Upload de Arquivos</h1>
      </header>
      <main>
        <FileUploader />
      </main>
    </div>
  );
}

export default App;
